import { Box, Grid } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { END_POINTS } from "constants/APIConstant";
import fetch from "auth/FetchInterceptor";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import CircularProgress from "@mui/material/CircularProgress";
import SnackbarModal from "component/shared/snackbar";
import ReactGA from "react-ga4";
import { parseApiDateTime, toCountDownIso } from "utils/parseApiDateTime";

export default function ForgetPass() {
  const intl = useIntl();

  const navigate = useNavigate();

  useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: "/forgetPass",
      title: "ForgetPass Page",
    });
  }, []);

  const [message, setMessage] = useState(null);

  const [loadingBtn, setLoadingBtn] = useState(null);

  // feedback
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // error
  const [openError, setOpenError] = useState(false);
  const handleOpenError = () => {
    setOpenError(true);
  };
  const handleCloseError = () => {
    setOpenError(false);
  };

  const [sendCode, setSendCode] = useState({
    email: "",
  });

  const handleSendCode = (e) => {
    let myEmail = { ...sendCode };
    myEmail[e.target.name] = e.target.value;
    setSendCode(myEmail);
  };

  async function sendCodeToEmail(e) {
    e.preventDefault();
    setLoadingBtn(true);
    await fetch
      .post(`${END_POINTS.FORGET_PASS}`, sendCode)
      .then((res) => {
        if (res?.state === true) {
          handleOpen();
          setMessage(
            res?.message || intl.formatMessage({ id: "successfullySend" })
          );

          // Validate and set timer - ensure it's at least 10 minutes from now
          const now = Date.now();
          const tenMinutesFromNow = now + 10 * 60 * 1000; // 10 minutes in milliseconds
          let validResetTime;

          if (res?.resetTime) {
            try {
              const resetTime = parseApiDateTime(res.resetTime);

              // Check if reset time is valid and is at least 10 minutes from now
              if (
                !isNaN(resetTime) &&
                resetTime > now &&
                resetTime >= tenMinutesFromNow
              ) {
                validResetTime = toCountDownIso(resetTime);
              } else {
                // Invalid or less than 10 minutes from now, set to 10 minutes from now
                validResetTime = new Date(tenMinutesFromNow).toISOString();
              }
            } catch (error) {
              console.error("Error parsing reset time:", error);
              // On error, set to 10 minutes from now
              validResetTime = new Date(tenMinutesFromNow).toISOString();
            }
          } else {
            // No reset time provided, set to 10 minutes from now
            validResetTime = new Date(tenMinutesFromNow).toISOString();
          }

          localStorage.setItem("countDownCapmasWebsiteTimer", validResetTime);
          setTimeout(() => {
            handleClose();
            navigate(`${APP_PREFIX_PATH}/resetCode/${res?.token}`);
          }, 1000);
        } else {
          message.error(res?.data?.message);
        }
        setLoadingBtn(false);
      })
      .catch((e) => {
        handleOpenError();
        setMessage(e.response?.data?.message);
        setLoadingBtn(false);
        setTimeout(() => {
          handleCloseError();
        }, 10000);
      });
  }

  return (
    <div className="d-flex align-items-center flex-column py-5">
      <Grid item xs={12} sx={{ textAlign: "center", mb: 3 }}>
        <h2 style={{ color: "var(--main-color)" }}>
          <FormattedMessage id="resetPass" />
        </h2>
      </Grid>
      <Box
        sx={{
          border: "1px solid #E8E8E8",
          borderRadius: "0.75rem",
          width: "50%",
          minWidth: "300px",
        }}
        className={"shadow"}
      >
        <div className="p-5">
          <form onSubmit={sendCodeToEmail}>
            <div className="mb-4">
              <label className="mb-2 fw-bold" htmlFor={"email"}>
                {intl.formatMessage({ id: "email" })}
              </label>
              <input
                type={"email"}
                onChange={handleSendCode}
                className="bg-transparent form-control fw-bold mx-auto py-2"
                style={{ fontSize: "14px" }}
                placeholder={"Your Email Address"}
                required
                name={"email"}
                id={"email"}
              />
            </div>
            <div className="text-center">
              <button type="submit" className="main-btn mx-auto">
                <span>
                  {loadingBtn ? (
                    <CircularProgress sx={{ color: "#fff" }} size={26} />
                  ) : (
                    intl.formatMessage({ id: "send" })
                  )}
                </span>
              </button>
            </div>
          </form>
        </div>
      </Box>

      {/* feedback */}
      <SnackbarModal
        open={open}
        onClose={handleClose}
        severity="success"
        message={message}
      />

      {/* error */}
      <SnackbarModal
        open={openError}
        onClose={handleCloseError}
        severity="error"
        message={message}
      />
    </div>
  );
}
